// Sticky Nav
let prevScrollPos = 0;
let curScrollPos = 0;
const topBar = document.querySelector('.site-header');
const topBarHeight = topBar.clientHeight;

export default function () {
    // console.log('scroll');
    curScrollPos = window.scrollY;

    if (curScrollPos > prevScrollPos && (curScrollPos - prevScrollPos >= 15)) {
        if (curScrollPos > topBarHeight) {
            topBar.classList.remove('is-sticky');
            topBar.classList.add('is-hidden');
        }
    } else if (curScrollPos < prevScrollPos) {
        if (curScrollPos > topBarHeight) {
            topBar.classList.add('is-sticky');
            topBar.classList.remove('is-hidden');
        } else {
            topBar.classList.remove('is-sticky');
        }
    }
    prevScrollPos = curScrollPos;
}

// window.addEventListener('scroll', stickyNav);